import { z } from "zod";

// Enums
const KycTierSchema = z.enum(["basic", "standard", "platinum"]);

const KycCountrySchema = z.enum(["Nigeria", "Ghana"]);

const GovernmentIDTypeSchema = z.enum([
  "ng_bvn",
  "ng_vnin",
  "ng_nin",
  "gh_passport",
  "gh_ssnit",
  "gh_voters_card",
  "gh_drivers_license",
]);

// Document Group is an array of government ID types
const DocumentGroupSchema = z.array(GovernmentIDTypeSchema);

// Main KycNextLevelRequirements schema
const KycNextLevelRequirementsSchema = z.object({
  country: KycCountrySchema,
  current_tier: KycTierSchema,
  next_tier: z.preprocess(
    (val) => (val === "" ? undefined : val), 
    KycTierSchema.optional()
  ),
  has_next_tier: z.boolean(),
  requirements: z.array(DocumentGroupSchema).optional(),
  message: z.string(),
  currency_limits: z.record(z.string(), z.number().int()).optional(),
});

// Type inference
type KycNextLevelRequirements = z.infer<typeof KycNextLevelRequirementsSchema>;
type GovernmentID = z.infer<typeof GovernmentIDTypeSchema>;
type KycDocumentGroup = z.infer<typeof DocumentGroupSchema>;

// Export
export {
  KycNextLevelRequirementsSchema,
  KycTierSchema,
  KycCountrySchema,
  GovernmentIDTypeSchema,
  DocumentGroupSchema,
};

export type { KycNextLevelRequirements, GovernmentID, KycDocumentGroup };
